import React, { FunctionComponent } from 'react'
import styles from './AvatarDescription.module.scss'

interface AvatarDescription {
  name?: string
  rol?: string
  identifier?: string
}

const AvatarDescription: FunctionComponent<AvatarDescription> = ({ name, rol, identifier }) => {
  return (
    <div className={styles.description}>
      <h6 className={styles.name}>{name}</h6>
      <p className={styles.rol}>{rol}</p>
      <p className={styles.rol}>{identifier}</p>
    </div>
  )
}

export default AvatarDescription
